import Components from "../components";
import moment from 'moment-timezone';

class Timestamp extends Components.Base {
  initialize() {
    this.setLocale();
    this.timestamp = this.$el.data('timestamp');
    if (this.timestamp) {
      this.$el.html(this.render(this.timestamp));
    }

    const refresh = this.$el.data('timestamp-refresh') || 10000;

    if (this.timestamp) {
      this.interval = window.setInterval(() => {
        this.$el.html(this.render(this.timestamp))
      }, parseInt(refresh, 10))
    }
  }

  unbind() {
    if(this.interval) {
      window.clearInterval(this.interval);
    }
  }

  render(timestamp) {
    let time;
    if (typeof timestamp === 'number') {
      time = moment.unix(timestamp);
    } else {
      time = moment(timestamp);
    }

    if (this.context.user && this.context.user.timezone) {
      time = time.tz(this.context.user.timezone);
    }

    const dateFormat = this.context.user.date_format || 'l';
    const timeFormat = this.context.user.time_format || 'LT Z';

    switch (this.$el.data('timestamp-format')) {
      case 'relative':
        return time.fromNow();
      case 'calendar':
        return time.calendar(null, { lastWeek: 'dddd [at] LT' });
      case 'date':
        return time.format(dateFormat);
      case 'time':
        return time.format(timeFormat);
      default:
        return time.format(`${dateFormat} [at] ${timeFormat}`);
    }
  }

  setLocale() {
    if (this.context.user) {
      if (!this.context.user.localeSet) {
        // Context is shared across all components. By setting this flag we prevent
        // other timestamp instances from setting the locale until the page is reloaded
        this.context.user.localeSet = true;

        moment.updateLocale('en', {
          relativeTime: {
            future: 'in %s',
            past: '%s',
            s: '< 1 min',
            m: '1 min',
            mm: '%d min',
            h: '1 h',
            hh: '%d h',
            d: '1 d',
            dd: '%d d',
            M: '1 mo',
            MM: '%d mo',
            y: '1 y',
            yy: '%d y',
          },
          calendar: {
            lastDay: `[Yesterday at] ${this.context.user.time_format || 'LT'}`,
            sameDay: this.context.user.time_format || '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            lastWeek: this.context.user.date_format || '[last] dddd [at] LT',
            nextWeek: 'dddd [at] LT',
            sameElse: this.context.user.date_format || 'L',
          },
        });
      }
    }
  }
}

Components.collection.register({
  selector: '[data-timestamp]',
  klass: Timestamp,
});
